import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 pt-20 lg:pt-24 overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-5" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full">
              <Icon name="Sparkles" size={16} color="var(--color-primary)" />
              <span className="text-sm font-medium text-primary">AI-Powered Book Creation</span>
            </div>

            <h1 className="text-4xl lg:text-6xl font-heading font-bold text-foreground leading-tight">
              Write Your Book In a Weekend and Position Yourself as the Authority in Your Field
            </h1>

            <p className="text-lg lg:text-xl text-muted-foreground leading-relaxed">
              AI powered system that helps you turn your experience into a polished, professional book in a fraction of the time. You no longer need months of effort or endless rewrites. You can go from idea to published in a single weekend with clear guidance from start to finish.
            </p>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-6 h-6 bg-success/10 rounded-full flex items-center justify-center mt-1">
                  <Icon name="Check" size={14} color="var(--color-success)" />
                </div>
                <p className="text-foreground">
                  <span className="font-semibold">10x Faster Writing:</span> Complete your manuscript in days with AI assistance
                </p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-6 h-6 bg-success/10 rounded-full flex items-center justify-center mt-1">
                  <Icon name="Check" size={14} color="var(--color-success)" />
                </div>
                <p className="text-foreground">
                  <span className="font-semibold">Your Authentic Voice:</span> AI learns and maintains your unique writing style
                </p>
              </div>

              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-6 h-6 bg-success/10 rounded-full flex items-center justify-center mt-1">
                  <Icon name="Check" size={14} color="var(--color-success)" />
                </div>
                <p className="text-foreground">
                  <span className="font-semibold">Complete Publishing Support:</span> From idea to published
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                variant="default"
                size="lg"
                iconName="ArrowRight"
                iconPosition="right"
                onClick={() => navigate('/user-registration')}>

                Start Your Book Today
              </Button>

              <Button
                variant="outline"
                size="lg"
                iconName="PlayCircle"
                iconPosition="left"
                onClick={() => document.getElementById('features-section')?.scrollIntoView({ behavior: 'smooth' })}>

                See How It Works
              </Button>
            </div>

            <div className="flex items-center space-x-8 pt-4">
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={20} color="var(--color-primary)" />
                <div>
                  <p className="text-2xl font-bold text-foreground">2,500+</p>
                  <p className="text-xs text-muted-foreground">Authors Published</p>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <Icon name="Star" size={20} color="var(--color-accent)" />
                <div>
                  <p className="text-2xl font-bold text-foreground">4.9/5</p>
                  <p className="text-xs text-muted-foreground">User Rating</p>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <Icon name="BookOpen" size={20} color="var(--color-secondary)" />
                <div>
                  <p className="text-2xl font-bold text-foreground">15K+</p>
                  <p className="text-xs text-muted-foreground">Books Created</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-border">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_13bf21a24-1764661260931.png"
                alt="Professional entrepreneur writing book at modern desk with laptop and coffee, surrounded by business books and natural lighting from large windows"
                className="w-full h-auto" />

            </div>

            <div className="absolute -top-6 -right-6 w-72 h-72 bg-primary/20 rounded-full blur-3xl" />
            <div className="absolute -bottom-6 -left-6 w-72 h-72 bg-secondary/20 rounded-full blur-3xl" />
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;